import { useCallback, useState } from 'react';

export const useStepper = (initialStep: number) => {
  const [page, setPage] = useState(initialStep);
  const [wizard_width, setWidth] = useState(500);

  const onNextStep = useCallback(() => {
    setPage(1);
    setWidth(1175);
  }, []);

  const onPrevStep = useCallback(() => {
    setPage(0);
    setWidth(500);
  }, []);

  const reset = useCallback(() => {
    setPage(initialStep);
    setWidth(500);
  }, [initialStep]);

  return {
    page,
    wizard_width,
    reset,
    onNextStep,
    onPrevStep,
  };
};
